import React from "react";

const ThankYouPage = () => {
  return (
    <div style={{ marginTop: "40%" }}>
      <center>
        <h1>THANK YOU</h1>
      </center>
    </div>
  );
};

export default ThankYouPage;
